const fr = {
  // Navigation
  nav: {
    family: 'InventoTrack Famille',
    person: 'personne',
    persons: 'personnes',
    scanner: 'Scanner',
    receipt: 'Ticket',
    account: 'Compte',
    logout: 'Déconnexion',
    alerts: 'alerte',
    alertsPlural: 'alertes',
  },
  // Stats cards
  stats: {
    householdItems: 'Articles du foyer',
    toBuy: 'À racheter',
    householdSize: 'Taille du foyer',
    clickToEdit: 'Cliquez pour modifier',
    dailyReport: 'Rapport du jour',
    send: 'Envoyer',
  },
  // Tabs
  tabs: {
    stock: 'Stock Foyer',
    shopping: 'Articles à acheter',
    budget: 'Budget',
    articles: 'Mes Articles',
    history: 'Historique',
    suggestions: 'Suggestions',
    ai: 'Assistant IA',
    learning: 'Apprentissage',
    support: 'Feedback & Support',
    about: 'À propos',
  },
  // Stock tab
  stock: {
    title: 'Stock du foyer',
    addArticle: 'Ajouter article',
    remaining: 'Reste',
    days: 'jours',
    daysShort: 'j',
    alert: 'À racheter !',
    noItems: 'Aucun article en stock',
    noItemsDesc: 'Ajoutez vos premiers articles pour commencer le suivi de votre stock familial.',
    buy: 'Acheter',
    consume: 'Consommer',
    stockLabel: 'Stock',
    threshold: 'Seuil',
    perPersonDay: 'par personne/jour',
    totalHouseholdDay: 'total foyer/jour',
  },
  // Articles tab
  articles: {
    title: 'Mes articles',
    addNew: 'Nouvel article',
    category: 'Catégorie',
    unit: 'Unité',
    perishable: 'Périssable',
    edit: 'Modifier',
    delete: 'Supprimer',
    noArticles: 'Aucun article',
    noArticlesDesc: 'Commencez par ajouter vos articles quotidiens.',
    confirmDelete: 'Confirmer la suppression',
    confirmDeleteMsg: 'Voulez-vous vraiment supprimer',
    deleteWarning: 'ainsi que tous ses mouvements associés ?',
    cancel: 'Annuler',
    confirm: 'Confirmer',
  },
  // Forms
  form: {
    name: 'Nom',
    category: 'Catégorie',
    unit: 'Unité',
    alertThreshold: 'Seuil d\'alerte de consommation (alarme quand ce seuil est atteint)',
    perishable: 'Périssable',
    expiryDate: 'Date limite',
    quantity: 'Quantité',
    source: 'Source',
    note: 'Note',
    save: 'Enregistrer',
    cancel: 'Annuler',
    add: 'Ajouter',
    close: 'Fermer',
  },
  // Movement types
  movement: {
    purchase: 'Achat',
    sale: 'Vente',
    consumption: 'Consommation',
    addMovement: 'Ajouter un mouvement',
    article: 'Article',
    type: 'Type de mouvement',
    quickPurchase: 'Achat rapide',
    enterQuantity: 'Entrer la quantité',
    validatePurchase: 'Valider l\'achat',
  },
  // Suggestions
  suggestions: {
    title: 'Articles suggérés',
    description: 'Articles courants pour un foyer',
    addQuick: 'Ajouter',
  },
  shoppingPlanner: {
    badge: 'Suggestions intelligentes',
    title: 'Articles à acheter',
    description: 'Retrouvez vos recommandations les plus utiles dans une vue mobile claire, priorisée selon vos achats récents et vos habitudes fréquentes.',
    customArticle: 'Ajouter un article libre',
    toBuySection: '🛒 Articles à acheter',
    toBuyDescription: 'Suggestions intelligentes à réapprovisionner ou à planifier.',
    stockSection: '🏠 Stock foyer',
    stockDescription: 'Vos articles déjà achetés, avec accès rapide au réassort.',
    emptySuggestions: 'Tout est sous contrôle pour le moment. Ajoutez un article libre ou attendez la prochaine recommandation.',
    emptyStock: 'Votre stock foyer apparaîtra ici dès vos premiers achats.',
    recent: 'Récent',
    frequent: 'Fréquent',
    threshold: 'Seuil',
    purchaseCount: 'Acheté {count} fois récemment',
    catalogHint: 'Suggestion issue du catalogue intelligent',
    moreIdeas: 'Autres idées utiles',
    buyAgain: 'Racheter',
  },
  budget: {
    title: 'Budget mensuel',
    description: 'Suivez vos dépenses du mois, ajustez chaque plafond directement sur sa carte et recevez des alertes utiles.',
    loading: 'Chargement du budget mensuel...',
    period: 'Période suivie',
    global: 'Budget global',
    remaining: 'Reste estimé',
    cardBudget: 'Budget cible',
    adjustOnCard: 'Curseur direct sur la carte',
    preciseEdit: 'Montant précis',
    useSuggestion: 'Utiliser la suggestion',
    saveThisBudget: 'Enregistrer',
    saving: 'Sauvegarde...',
    tapToEdit: 'Touchez pour éditer',
    masterRuleTitle: 'Règle budget maître/esclaves',
    masterRuleHint: 'La somme des budgets catégories doit rester inférieure ou égale au budget global.',
    allocationSummary: 'Total catégories: {total} € / Budget global: {global} €',
    maxAllowedForCategory: 'Maximum autorisé pour cette catégorie: {amount} €',
    globalMinByCategories: 'Si vous baissez le budget global, les catégories sont ajustées automatiquement pour rester dans {amount} €.',
    suggestedGlobal: 'Suggestion calculée : {amount} € selon votre historique récent.',
    suggestedCategory: 'Budget suggéré : {amount} €',
    noAlerts: 'Aucune alerte pour le moment. Votre budget reste sous contrôle.',
    smartAlertsTitle: 'Alertes intelligentes',
    smartAlertsDescription: 'Basées sur le mois en cours, sans encombrer l’historique.',
    badges: {
      customized: 'Budget personnalisé',
      suggested: 'Budget suggéré',
    },
    categories: {
      courses: 'Courses',
      vetements: 'Vêtements',
      restaurant: 'Restaurant',
      loisirs: 'Loisirs',
    },
    alertLabels: {
      global: 'budget global',
      courses: 'budget courses',
      vetements: 'budget vêtements',
      restaurant: 'budget restaurant',
      loisirs: 'budget loisirs',
    },
    alertLevels: {
      info: 'Info',
      warning: 'Alerte',
      exceeded: 'Dépassé',
    },
    alertMessages: {
      info: 'Vous avez atteint 80 % du {label}.',
      warning: 'Le {label} est presque atteint.',
      exceeded: 'Le {label} est dépassé.',
    },
    labels: {
      spent: '{amount} € dépensés',
    },
    success: {
      saved: 'Budget mensuel mis à jour',
    },
    errors: {
      load: 'Impossible de charger le budget mensuel',
      save: 'Erreur lors de la sauvegarde du budget',
      categorySumExceedsGlobal: 'Le total des catégories dépasse le budget global de {extra} €.',
      categoryClampedToGlobal: 'Budget catégorie ajusté automatiquement à {amount} € pour respecter le budget global.',
    },
  },
  newItem: {
    modalTitle: 'Nouvel article',
    modalDescription: 'Ajoutez un nouvel article à votre foyer avec un popup complet même sur téléphone.',
    suggestionButton: 'Suggestions',
    menuTitle: '✨ Suggestions intelligentes',
    menuDescription: 'Les articles achetés récemment apparaissent d’abord, puis le reste des recommandations juste en dessous.',
    suggestionLabel: 'Suggestions d’articles',
    suggestionHelp: 'Utilisez le menu déroulant pour retrouver rapidement les articles récents et les suggestions utiles.',
    dropdownTitle: 'Choisir un article suggéré',
    dropdownSubtitle: 'Menu déroulant optimisé pour téléphone',
    searchPlaceholder: 'Rechercher un article, une catégorie ou une unité...',
    noSuggestionResult: 'Aucune suggestion trouvée',
    recentSuggestions: 'Suggestions récentes',
    allSuggestions: 'Toutes les suggestions',
    recentBadge: 'Récent',
    alreadyInStock: 'Déjà dans votre stock',
    tapToFill: 'Touchez pour préremplir',
    nameLabel: 'Nom de l’article',
    namePlaceholder: 'Ex : Bananes, Lait, Riz...',
    inputHelp: 'Le menu déroulant regroupe les achats récents et le reste du catalogue recommandé.',
    initialQuantity: 'Quantité initiale (optionnel)',
    initialPrice: 'Prix initial (obligatoire pour achat)',
    knownTitle: '✅ Article reconnu !',
    unknownTitle: '⚠️ Article non reconnu',
    unknownDescription: 'Veuillez estimer votre consommation quotidienne par personne.',
    dailyQuantity: 'Quantité par jour',
  },
  notifications: {
    title: 'Notifications ({count})',
    empty: 'Aucune notification',
    markRead: 'Marquer lu',
    markAll: 'Marquer toutes comme lues',
    markAllSuccess: 'Toutes les notifications marquées comme lues',
    budgetTitle: 'Alerte budget {month}',
    now: 'À l’instant',
    minutesAgo: 'Il y a {count} min',
    hoursAgo: 'Il y a {count} h',
    daysAgo: 'Il y a {count} j',
  },
  // AI Assistant
  ai: {
    title: 'Assistant IA - Estimation',
    description: 'L\'IA analyse votre consommation et estime la durée de vos stocks',
    estimate: 'Estimer',
    dailyConsumption: 'Consommation/jour',
    confidence: 'Confiance',
    source: 'Source',
    noEstimation: 'Cliquez sur "Estimer" pour obtenir une analyse IA',
    smartTitle: 'Estimation intelligente de consommation',
    smartDesc: 'Notre IA analyse vos habitudes de consommation et estime les besoins de votre foyer.',
    smartHint: 'Cliquez sur le bouton IA (cerveau) à côté de chaque article pour obtenir une estimation personnalisée basée sur votre historique et la taille de votre foyer.',
    recentEstimations: 'Estimations récentes',
    householdOf: 'Foyer de',
    referenceFallback: 'Estimation basée sur les données de référence',
  },
  // Learning
  learning: {
    title: 'Apprentissage automatique',
    description: 'Le système apprend de vos habitudes de consommation pour améliorer ses estimations',
    learned: 'Appris',
    base: 'Base',
    efficiency: 'Efficacité',
    records: 'enregistrements',
    noPatterns: 'Aucun apprentissage enregistré',
    noPatternsDesc: 'Les patterns de consommation s\'amélioreront avec l\'utilisation.',
    householdSize: 'Taille du foyer',
    smartTitle: 'Système d\'apprentissage intelligent',
    smartDesc: 'InventoTrack apprend automatiquement de vos habitudes de consommation. À chaque fois que vous cliquez sur le bouton consommation (-), l\'IA s\'améliore et adapte les alertes à votre foyer.',
    referencesTitle: 'Données de référence utilisées',
    learnedPatterns: 'Patterns appris',
    learnedConsumption: 'Consommation apprise',
    baseConsumption: 'Consommation de référence',
    basedOn: 'Basé sur',
    record: 'enregistrement',
    recordsPlural: 'enregistrements',
    learningLabel: 'Apprentissage',
    noLearningYet: 'Pas encore d\'apprentissage',
    noLearningStart: 'Commencez à enregistrer vos consommations en cliquant sur le bouton orange (-) à côté de vos articles.',
    noLearningHint: 'Plus vous utilisez l\'application, plus les estimations deviennent précises !',
  },
  // Profile
  profile: {
    editProfile: 'Modifier le profil',
    householdSize: 'Nombre de personnes dans le foyer',
    reportDays: 'Jours de rapport',
    reportTime: 'Heure d\'envoi du rapport',
    allDays: 'Tous les jours',
    save: 'Enregistrer',
  },
  // Password
  password: {
    change: 'Changer le mot de passe',
    current: 'Mot de passe actuel',
    new: 'Nouveau mot de passe',
    confirm: 'Confirmer le nouveau mot de passe',
    submit: 'Changer le mot de passe',
  },
  feedback: {
    title: 'Feedback & Support',
    description: 'Signalez un bug, demandez de l’aide ou partagez votre avis sans quitter l’application.',
    communityTitle: 'Avis et service client',
    communityDescription: 'Un espace simple pour nous dire ce qui fonctionne et ce qu’il faut améliorer.',
    communityText: 'Chaque retour aide SmartInventory à mieux servir la gestion de stock maison, la liste de courses intelligente et le suivi des achats du foyer.',
    reviewPromptTitle: 'Publiez aussi votre avis sur Google Play',
    reviewPromptText: 'Si l’application vous aide au quotidien, vous pouvez également laisser un avis public depuis le Play Store.',
    playStoreButton: 'Ouvrir Google Play',
    recentTitle: 'Vos derniers envois',
    recentDescription: 'Historique rapide de vos messages envoyés à l’équipe.',
    empty: 'Aucun message envoyé pour le moment.',
    types: {
      bug: 'Signalement de bug',
      support: 'Service client',
      review: 'Avis utilisateur',
    },
    form: {
      type: 'Type de demande',
      contact: 'Email de contact',
      rating: 'Note utilisateur',
      message: 'Description',
      messagePlaceholder: 'Décrivez le bug, votre besoin ou votre retour utilisateur.',
      screenshot: 'Capture d’écran facultative',
      screenshotHint: 'PNG, JPG ou WebP. Taille conseillée inférieure à 1,5 Mo.',
      send: 'Envoyer',
      sending: 'Envoi en cours...',
    },
    success: {
      sent: 'Votre message a bien été envoyé.',
    },
    errors: {
      submit: 'Impossible d’envoyer votre message.',
      imageTooLarge: 'La capture est trop volumineuse.',
    },
  },
  about: {
    badge: 'Pourquoi SmartInventory ?',
    title: 'À propos de SmartInventory',
    description: 'SmartInventory est une application pensée pour la gestion de stock maison, la liste de courses intelligente, le suivi des achats et une consommation plus responsable. Elle vous aide à mieux piloter votre budget alimentaire et à visualiser vos habitudes réelles.',
    valueCardTitle: 'Promesse produit',
    valueCardText: 'Moins d’achats impulsifs, plus de visibilité, et un budget mieux maîtrisé pour tout le foyer.',
    openOnboarding: 'Revoir l’introduction',
    keywords: ['gestion de stock maison', 'liste de courses intelligente', 'budget alimentaire', 'consommation responsable', 'suivi des achats'],
    cards: {
      smartShoppingTitle: 'Courses plus intelligentes',
      smartShoppingDescription: 'Des suggestions utiles, pas envahissantes.',
      smartShoppingText: 'SmartInventory met en avant les produits récents et fréquents pour vous aider à préparer vos courses sans repartir de zéro.',
      budgetTitle: 'Budget alimentaire plus clair',
      budgetDescription: 'Une vue concrète sur vos dépenses.',
      budgetText: 'Suivez vos dépenses du mois, comparez vos habitudes et adaptez votre budget alimentaire avec des repères compréhensibles.',
      responsibleTitle: 'Consommation plus responsable',
      responsibleDescription: 'Acheter ce qu’il faut, quand il faut.',
      responsibleText: 'En visualisant votre stock foyer et votre historique, vous limitez le gaspillage et prenez de meilleures décisions d’achat.',
    },
  },
  onboarding: {
    title: 'Découvrir SmartInventory',
    skip: 'Passer',
    previous: 'Précédent',
    next: 'Suivant',
    finish: 'Commencer',
    step: 'Écran {number}',
    impulse: {
      headline: '🛒 Évitez les achats impulsifs',
      body: 'Planifiez vos courses intelligemment et achetez uniquement ce dont vous avez besoin grâce aux suggestions et à votre stock réel.',
    },
    history: {
      headline: '📊 Visualisez votre historique',
      body: 'Suivez vos habitudes d’achat, observez votre rythme de consommation et repérez les produits que vous rachetez le plus souvent.',
    },
    budget: {
      headline: '💰 Maîtrisez votre budget',
      body: 'Adaptez vos achats selon votre budget, personnalisez vos plafonds et construisez une gestion plus sereine de vos dépenses.',
    },
  },
  // Purge
  purge: {
    title: 'Zone de danger',
    warning: 'Cette action supprimera TOUTES vos données (articles, mouvements, achats). Cette action est irréversible !',
    button: 'Purger toutes mes données',
    confirmTitle: 'ATTENTION',
    confirmMessage: 'Êtes-vous ABSOLUMENT sûr de vouloir supprimer TOUTES vos données ?\n\nCette action est IRRÉVERSIBLE !\n\nTous vos articles, mouvements et historique seront définitivement supprimés.',
    success: 'Données purgées avec succès',
    error: 'Erreur lors de la purge des données',
  },
  // Receipt Scanner
  receipt: {
    title: 'Scanner un ticket de caisse',
    uploading: 'Envoi en cours...',
    analyzing: 'Analyse du ticket par l\'IA...',
    analyzeStep1: 'Envoi des images au serveur...',
    analyzeStep2: 'L\'IA analyse votre ticket...',
    analyzeStep3: 'Extraction des articles...',
    analyzeComplete: 'Analyse terminée !',
    addPhotos: 'Ajouter des photos',
    takePhoto: 'Prendre une photo',
    maxPhotos: 'Maximum 3 photos',
    analyze: 'Analyser le ticket',
    detected: 'articles détectés',
    addAll: 'Ajouter tous les articles',
    store: 'Magasin',
    date: 'Date',
    total: 'Total',
  },
  // Barcode Scanner
  barcode: {
    title: 'Scanner un code-barres',
    scanning: 'Scan en cours...',
    productFound: 'Produit trouvé',
    productNotFound: 'Produit non trouvé',
    addToStock: 'Ajouter au stock',
    enterManually: 'Saisie manuelle',
  },
  // Auth
  auth: {
    login: 'Connexion',
    register: 'Inscription',
    username: 'Email ou nom d\'utilisateur',
    email: 'Email',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    userType: 'Type d\'utilisateur',
    particular: 'Particulier',
    professional: 'Professionnel',
    householdSize: 'Nombre de personnes dans le foyer',
    loginButton: 'Se connecter',
    registerButton: 'S\'inscrire',
    noAccount: 'Pas de compte ?',
    hasAccount: 'Déjà un compte ?',
    forgotPassword: 'Mot de passe oublié ?',
    resetPassword: 'Réinitialiser le mot de passe',
    newPassword: 'Nouveau mot de passe',
    resetButton: 'Réinitialiser',
    backToLogin: 'Retour à la connexion',
  },
  // Common
  common: {
    loading: 'Chargement...',
    loadingFamily: 'Chargement de votre espace familial...',
    error: 'Erreur',
    success: 'Succès',
    yes: 'Oui',
    no: 'Non',
    ok: 'OK',
    search: 'Rechercher',
    filter: 'Filtrer',
    noData: 'Aucune donnée',
    refresh: 'Actualiser',
  },
  // Days
  days: {
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche',
  },
  // Categories
  categories: {
    food: 'Alimentation',
    drink: 'Boisson',
    hygiene: 'Hygiène',
    household: 'Ménage',
    dairy: 'Laitier',
    bakery: 'Boulangerie',
    canned: 'Conserve',
    other: 'Autre',
  },
  // Units
  units: {
    kg: 'kg',
    g: 'g',
    L: 'L',
    ml: 'mL',
    pieces: 'pièces',
  },
  // History
  history: {
    title: 'Historique des achats',
    weekly: 'Par semaine',
    monthly: 'Par mois',
    noHistory: 'Aucun historique d\'achats',
    total: 'Total',
    purchases: 'achats',
    spent: 'dépensé',
    week: 'Semaine',
  },
  // Language
  lang: {
    switchTo: 'English',
    current: 'FR',
  },
  // Subscription
  subscription: {
    title: 'Abonnement & Paiement',
    trialActive: 'Essai gratuit actif',
    trialExpired: 'Essai gratuit expiré',
    active: 'Abonnement actif',
    expired: 'Abonnement expiré',
    cancelled: 'Abonnement annulé',
    daysLeft: 'jours restants',
    subscribe: 'S\'abonner',
    cancel: 'Annuler l\'abonnement',
    price: '/mois',
    paypal: 'PayPal',
    creditCard: 'Carte bancaire',
    cardLast4: '4 derniers chiffres',
    paymentHistory: 'Historique des paiements',
    noPayments: 'Aucun paiement',
    startTrial: 'Commencer l\'essai gratuit',
    trialInfo: '7 jours d\'essai gratuit, puis 2,99 €/mois',
    payNow: 'Payer maintenant',
    mockNotice: 'Mode démonstration - Aucun vrai paiement ne sera effectué',
  },
  // Household
  household: {
    title: 'Mon Foyer',
    create: 'Créer un foyer',
    name: 'Nom du foyer',
    members: 'Membres',
    invite: 'Inviter',
    invitePlaceholder: 'Email ou nom d\'utilisateur',
    pending: 'En attente',
    owner: 'Propriétaire',
    member: 'Membre',
    leave: 'Quitter le foyer',
    delete: 'Supprimer le foyer',
    noHousehold: 'Vous n\'appartenez à aucun foyer',
    createInfo: 'Créez un foyer pour partager votre inventaire avec votre famille',
    invitations: 'Invitations reçues',
    accept: 'Accepter',
    decline: 'Refuser',
    noInvitations: 'Aucune invitation',
    sharedStock: 'Stock partagé',
    remove: 'Retirer',
    invitedBy: 'Invité par',
  },
};

export default fr;
